// offerfx.js (art agent, LIGHT.md §1 and §3): DOM-only light for the shell. Safe on every device: it does nothing until
// its elements exist and never throws into the film.
// 1. The hold ring: gate.js drives #ring-fg's dash offset; this mirrors that progress into --hold, which fills the ring's
//    conic sweep of the chapter accents (.ring-cone). A MutationObserver, so there is no per-frame work of our own.
// 2. The offer: the holographic CTA's highlight and film follow the pointer (--mx/--my/--hx) and the tier cards' iridescent
//    edges turn toward it (--ea). Only while the offer is on screen, at most once per frame.
// 3. Reduced motion (?reduced or the media query): static gradients, no pointer tracking.
const RING_C = 276.46; // 2*pi*44, the ring's circumference in gate.js
const Q = new URLSearchParams(location.search);
const REDUCED = Q.has('reduced') || !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);

function ringMirror() {
  const ring = document.getElementById('ring'), fg = document.getElementById('ring-fg');
  if (!ring || !fg || typeof MutationObserver === 'undefined') return;
  let last = -1;
  const sync = () => {
    const off = parseFloat(fg.style.strokeDashoffset);
    const k = Number.isFinite(off) ? Math.min(1, Math.max(0, 1 - off / RING_C)) : 0;
    const q = Math.round(k * 400) / 400;
    if (q !== last) { ring.style.setProperty('--hold', String(q)); last = q; }
  };
  new MutationObserver(sync).observe(fg, { attributes: true, attributeFilter: ['style'] });
  sync();
}

function offerFx() {
  const offer = document.getElementById('offer'), cta = document.getElementById('cta');
  if (!offer || !cta) return;
  if (REDUCED) { document.documentElement.classList.add('holo-static'); return; }
  const tiers = Array.from(offer.querySelectorAll('.tier'));
  let visible = typeof IntersectionObserver === 'undefined', raf = 0, px = 0, py = 0;
  if (!visible) new IntersectionObserver((es) => { for (const e of es) visible = e.isIntersecting; }, { rootMargin: '0px 0px 10% 0px' }).observe(offer);
  const frame = () => {
    raf = 0;
    const r = cta.getBoundingClientRect();
    const mx = (px - r.left) / Math.max(1, r.width), my = (py - r.top) / Math.max(1, r.height);
    cta.style.setProperty('--mx', `${(Math.max(-0.5, Math.min(1.5, mx)) * 100).toFixed(1)}%`);
    cta.style.setProperty('--my', `${(Math.max(-1, Math.min(2, my)) * 100).toFixed(1)}%`);
    cta.style.setProperty('--hx', Math.max(-1, Math.min(1, (px / Math.max(1, innerWidth)) * 2 - 1)).toFixed(3));
    for (const t of tiers) {
      const b = t.getBoundingClientRect();
      const a = (Math.atan2(py - (b.top + b.height / 2), px - (b.left + b.width / 2)) * 180) / Math.PI + 90;
      t.style.setProperty('--ea', `${a.toFixed(1)}deg`);
    }
  };
  addEventListener('pointermove', (e) => {
    if (!visible) return;
    px = e.clientX; py = e.clientY;
    if (!raf) raf = requestAnimationFrame(frame);
  }, { passive: true });
}

function init() {
  try { ringMirror(); } catch (e) { /* cosmetic only */ }
  try { offerFx(); } catch (e) { /* cosmetic only */ }
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

export {};
